<template>
  <div class="page" v-cloak>
    <van-nav-bar left-arrow fixed title="商品专区" id="nav-bar" @click-left="onClickLeft" @click-right="onClickRight">
      <template #right>
        <van-icon size="20" name="phone-o" />
      </template>
    </van-nav-bar>

    <div class="top-bg" v-for="(item, index) in goods_list" :key="index" @click="goBirthProduct(item)">
      <img :src="item.banner" alt="">
      <p>{{ item.company_name }}</p>
    </div>

  </div>
</template>
  
  <script>
import imgTextRow from "@/components/img-text-block/img-text-block.vue";

export default {
  name: "ProductList",
  components: { imgTextRow },
  props: {},
  data() {
    return {
      //  this.$router.push({ path: `/birth-company-list/${even.r_id}` });
      pid: this.$route.params && this.$route.params.pid,
      goods_list: [],
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      let _this = this;
      let data = {
        pid: this.pid,
      };

      this.$post("/api/birth_company_list", data, data).then((res) => {
        console.log(res.data.data);

        if (res.data.code == 0) {
          _this.goods_list = res.data.data;
        } else {
          this.$toast.fail(res.data.message);
        }
      });
    },
    goBirthProduct(item) {
      console.log(item);
      if (item.type == 2 || item.type == "2") {
        // 有子公司
        this.$router.push({ path: `/birth-company-list/${item.id}` });
      } else {
        // 没有子公司
        this.$router.push({
          name: "birth-index",
          query: {
            company_id: item.id,
          },
        });
      }
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      this.MakeCall(); //拨打电话
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.page {
  height: 100%;
  width: 100%;
  background-color: #f9f9f9;

  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE */
  scrollbar-width: none; /* Firefox */
  padding: 50px 0;

  .top-bg {
    width: 100%;
    padding: 10px 20px;
    background-color: #fff;
    margin-bottom: 10px;
    img {
      display: block;
      width: 100%;
      height: 160px;
      box-shadow: 0 0 8px rgb(0 0 0 / 30%);
      border-radius: 5px;
    }
    p {
      line-height: 30px;
      font-weight: bold;
      font-size: 17px;
      text-align: center;
      color: #272530;
    }
  }
}
</style>
  